import { Controller } from '@hotwired/stimulus'

// Suggests a slug from the English title until the slug field is edited by hand.
export default class extends Controller<HTMLElement> {
  static targets = ['source', 'slug']

  declare readonly sourceTarget: HTMLInputElement
  declare readonly slugTarget: HTMLInputElement

  generate(): void {
    if (this.slugTarget.dataset.touched === 'true') return
    this.slugTarget.value = this.sourceTarget.value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
  }

  markTouched(): void {
    this.slugTarget.dataset.touched = 'true'
  }
}
